import { render, staticRenderFns } from "./DevicesByRoomTab.vue?vue&type=template&id=cf876c52"
import script from "./DevicesByRoomTab.vue?vue&type=script&lang=js"
export * from "./DevicesByRoomTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports